import React, {Component} from 'react';
import {Button, Col, Divider, Drawer, Form, Input, Row, Select, Switch} from 'antd';
import {createClient, deleteClient, updateClient} from "../../services/ClientsService";
import {isAdminRole} from "../../services/UsersService";
import TimezonePicker from 'react-timezone';
import moment from 'moment-timezone';

const {Option} = Select;
const {TextArea} = Input;
const DEFAULT_ZONE_ID = "America/Guayaquil"

export class ClientBase extends Component {

    constructor(props) {
        super(props);

        let client = props.client;
        this.state = {
            key: client.id,
            client: client,
            editVisible: false,
            isAdmin: isAdminRole(),
            currentClient: props.currentClient,
            id: {
                value: ''
            },
        };
    };

    deleteClient = (client) => {
        this.setState({isLoading: true});
        deleteClient(client.id).then(() => {
            this.props.onDelete(client);
        });
    };

    saveClient = () => {
        this.setState({isLoading: true});
        let client = this.state.client;
        if (!client.zoneId) {
            client.zoneId = DEFAULT_ZONE_ID
        }
        let clientFunction = this.state.key === undefined ?
            createClient(client) :
            updateClient(client);
        clientFunction.then(clientFromDb => {
            this.props.onSave(clientFromDb);
            this.setState({
                editVisible: false
            });
        }).catch(error => {
            this.setState({
                "id": {
                    validateStatus: 'error',
                    errorMsg: 'Id de cliente duplicado'
                }
            });
        });
    };

    showDrawer = () => {
        this.setState({
            editVisible: true,
            keyValue: new Date().getTime(),
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.saveClient();
            } else {
                if (err["id" + this.getKey()] && err["id" + this.getKey()].errors) {
                    this.setState({
                        "id": {
                            validateStatus: 'error',
                            errorMsg: (err["id" + this.getKey()].errors[0]['message'])
                        }
                    });
                } else {
                    this.setState({
                        "id": {
                            validateStatus: 'success',
                            errorMsg: ""
                        }
                    });
                }
            }
        });
    };

    onClose = () => {
        this.setState({
            editVisible: false
        });
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    handleClientClientValues = (clientId, property, value) => {
        let client = this.state.client;
        if (!client.clients[clientId]) {
            client.clients[clientId] = {};
        }
        client.clients[clientId][property] = value;
        this.setState({client: client});
    };

    handleClientValues = (property, value) => {
        let client = this.state.client;
        client[property] = value;
        this.setState({client: client});
    };

    getKey = () => {
        return (this.state.key ? this.state.key : "") + (this.state.keyValue ? this.state.keyValue : "");
    };

    componentDidUpdate() {
        const changes = {
            currentClient: this.props.currentClient,
        };
        const values = this.props.currentClient ? JSON.stringify(changes) : "{}";
        if (!this.state.propValues || this.state.propValues !== values) {
            this.setState({
                propValues: values,
                groups: this.props.groups ? this.props.groups : this.state.groups,
                currentClient: this.props.currentClient ? this.props.currentClient : this.state.currentClient
            });
        }
    }

    customButtons(key, id) {
        return "";
    }

    getTimeZoneDate(date, timeZone) {
        return moment.tz(date, timeZone).format('DD/MM/YYYY HH:mm:ss')
    }

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        const key = this.getKey();

        let childrenGroups = [];
        if (this.state.groups) {
            Object.values(this.state.groups).forEach(
                group => {
                    childrenGroups.push(<Option key={group.id}>{group.name}</Option>)
                }
            );
        }

        return <span key={"editRow" + key}>
            <Drawer
                title={'Cliente'}
                placement="right"
                closable={true}
                onClose={this.onClose}
                maskClosable={false}
                width={'calc((100% - 1000)>0?790:100%)'}
                visible={this.state.editVisible}
                key={"drawer-" + key}
                style={{
                    height: 'calc(100% - 55px)',
                    overflow: 'auto',
                    paddingBottom: 53
                }}>
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item label={'Id'} required={true}
                                       validateStatus={this.state.id.validateStatus}>
                                {getFieldDecorator("id" + key, {
                                    initialValue: (this.state.client && this.state.client.id) ? this.state.client.id : "",
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio'
                                    }]
                                })(
                                    <Input placeholder={'Id'} disabled={this.state.key !== undefined}
                                           onChange={(value) => {
                                               this.handleClientValues("id", value.target.value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                           <Form.Item label={'Habilidado'}>
                                    {getFieldDecorator('enabled' + key, {})(
                                        <Switch
                                            checked={this.state.client && this.state.client.enabled}
                                            onChange={(value) => {
                                                this.handleClientValues("enabled", value)
                                            }}/>
                                    )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <Divider/>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'Solicitar ubicación'} required={false}>
                                {getFieldDecorator('requestLocation' + key, {})(
                                    <Switch
                                        checked={this.state.client && this.state.client.requestLocation}
                                        onChange={(value) => {
                                            this.handleClientValues("requestLocation", value)
                                        }}/>
                                )}
                            </Form.Item>
                        </Col>
                        {
                            this.state.client && this.state.client.requestLocation ?
                                <Col span={12}>
                                    <Form.Item label={'Latitud'}>
                                        {getFieldDecorator("latitude" + key, {
                                            initialValue: (this.state.client && this.state.client.latitude) ? this.state.client.latitude : "",
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio'
                                            }]
                                        })(
                                            <Input placeholder={'Latitud'}
                                                   onChange={(value) => {
                                                       this.handleClientValues("latitude", value.target.value)
                                                   }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col> : null
                        }
                        {
                            this.state.client && this.state.client.requestLocation ?
                                <Col span={12}>
                                    <Form.Item label={'Radio (m)'}>
                                        {getFieldDecorator("radio" + key, {
                                            initialValue: (this.state.client && this.state.client.radio) ? this.state.client.radio : "",
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio'
                                            }]
                                        })(
                                            <Input placeholder={'Radio (m)'}
                                                   onChange={(value) => {
                                                       this.handleClientValues("radio", value.target.value)
                                                   }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col> : null
                        }
                        {
                            this.state.client && this.state.client.requestLocation ?
                                <Col span={12}>
                                    <Form.Item label={'Longitud'}>
                                        {getFieldDecorator("longitude" + key, {
                                            initialValue: (this.state.client && this.state.client.longitude) ? this.state.client.longitude : "",
                                            rules: [{
                                                required: true,
                                                message: 'Campo obligatorio'
                                            }]
                                        })(
                                            <Input placeholder={'Longitud'}
                                                   onChange={(value) => {
                                                       this.handleClientValues("longitude", value.target.value)
                                                   }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col> : null
                        }
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <Divider/>
                            <Form.Item label={'Nombre'} required={true}>
                                {getFieldDecorator("name" + key, {
                                    initialValue: (this.state.client && this.state.client.name) ? this.state.client.name : "",
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio'
                                    }]
                                })(
                                    <Input placeholder={'Nombre'}
                                           onChange={(value) => {
                                               this.handleClientValues("name", value.target.value)
                                           }}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={24}>
                            <Form.Item label={'Dirección'} required={true}>
                                {getFieldDecorator('address' + key, {
                                    initialValue: (this.state.client && this.state.client.address) ? this.state.client.address : "",
                                    rules: [{
                                        required: true, message: 'Campo obligatorio',
                                    }],
                                })(
                                    <TextArea placeholder={'Dirección'}
                                              type="address" onChange={(value) => {
                                        this.handleClientValues("address", value.target.value)
                                    }}/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={24}>
                        <Col span={12} className={"timezone"}>
                            <div className={"ant-form-item-label"}><label>{'Zona horaria'}</label></div>
                                    <TimezonePicker
                                        value={this.state.client && this.state.client.zoneId ? this.state.client.zoneId : DEFAULT_ZONE_ID}
                                        onChange={timezone => this.handleClientValues("zoneId", timezone)}
                                        inputProps={{
                                            placeholder: 'Seleccionar zona horaria',
                                            name: 'timezone',
                                        }}
                                    />
                        </Col>
                    </Row>
                    <div className="form-footer-separator">
                        <Button onClick={this.onClose}>
                            {'Cancelar'}
                        </Button>
                        <Button className="mrg-left" type="primary" htmlType="submit">
                            {'Aceptar'}
                        </Button>
                    </div>
                </Form>
                <div className="ant-table-wrapper"></div>
            </Drawer>
            {
                this.customButtons(key, this.state.client.id)
            }
        </span>
    }
}


// WEBPACK FOOTER //
// ./src/app/views/clients/ClientBase.js